import { render, staticRenderFns } from "./academica.vue?vue&type=template&id=678126f0&lang=html"
import script from "./academica.vue?vue&type=script&lang=js"
export * from "./academica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports